// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + chunkId + "-" + {"167":"c597e2ad06ff242d42b9","325":"6629022d755cf96ccf71","636":"d73586c017a6fc29c0ff"}[chunkId] + ".js";
};